var React = require('react');

function TwitterInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17 4.00637C16.3906 4.42575 15.7159 4.74651 15.0018 4.95629C14.2168 4.07562 12.9517 3.76679 11.8341 4.18298C10.7164 4.59917 9.98396 5.65185 10 6.81888V7.43975C7.7286 7.49721 5.57856 6.44138 4.27273 4.62723C4.27273 4.62723 1.72727 10.215 7.45455 12.6985C6.14397 13.5664 4.58274 15.0144 3 14.953C8.72727 18.0573 15.7273 13.9402 15.7273 6.80026C15.7267 6.62732 15.7096 6.4548 15.6764 6.28494C16.3258 5.66004 16.7842 4.87106 17 4.00637Z","fill":"currentColor"}));
}

TwitterInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","color":"#161633","fill":"none"};

module.exports = TwitterInline;

TwitterInline.default = TwitterInline;
